import {PROJECTS} from './projectsActionTypes';

export function getProjects(reloadWithoutChats = false) {
    return {
        type: PROJECTS.GET_PROJECTS,
        payload: {
            client: 'default',
            request: {
                url: `projects`,
                method: 'get',
                reloadWithoutChats: reloadWithoutChats
            }
        }
    };
}
export function getProjectsAvatars() {
    return {
        type: PROJECTS.GET_PROJECTS_AVATARS,
        payload: {
            client: 'default',
            request: {
                url: `projects/avatars`,
                method: 'get',
            }
        }
    };
}

export function getProject(id, needReloadProjects = false, signal) {
    return {
        type: PROJECTS.GET_PROJECT,
        payload: {
            client: 'default',
            request: {
                url: `projects/${id}`,
                method: 'get',
                signal: signal,
                needReloadProjects
            }
        }
    };
}

export function getProjectReviewEmployee(id) {
    return {
        type: PROJECTS.GET_PROJECT_REVIEW_EMPLOYEE,
        payload: {
            client: 'default',
            request: {
                url: `projects/${id}/employees/review`,
                method: 'get'
            }
        }
    };
}

export function getProjectChats(id) {
    return {
        type: PROJECTS.GET_PROJECT_CHATS,
        payload: {
            client: 'default',
            request: {
                url: `projects/${id}/chats`,
                method: 'get'
            }
        }
    };
}

export function getProjectMembersList(id) {
    return {
        type: PROJECTS.GET_PROJECT_MEMBERS_LIST,
        payload: {
            client: 'default',
            request: {
                url: `projects/${id}/members`,
                method: 'get'
            }
        }
    };
}

export function getProjectChatsListNew(projectId, chatId) {
    return {
        type: PROJECTS.GET_PROJECT_CHATS_LIST_NEW,
        payload: {
            client: 'default',
            request: {
                url: `projects/${projectId}/chats/${chatId}/messages-new?perPage=9999`,
                method: 'get',
            }
        }
    };
}

export function getProjectChatsList(projectId, chatId,page = 1) {
    return {
        type: PROJECTS.GET_PROJECT_CHATS_LIST,
        payload: {
            client: 'default',
            request: {
                url: `projects/${projectId}/chats/${chatId}/messages?perPage=60&page=${page}`,
                method: 'get',
            }
        }
    };
}

export function postProjectChatsListReadAll(projectId, chatId) {
    return {
        type: PROJECTS.POST_PROJECT_CHATS_LIST_READ_ALL,
        payload: {
            client: 'default',
            request: {
                url: `projects/${projectId}/chats/${chatId}/read-all`,
                method: 'post'
            }
        }
    };
}

export function postProjectChatsListReadGroup(projectId, chatId, messageIds) {
    return {
        type: PROJECTS.POST_PROJECT_CHATS_LIST_READ_GROUP,
        payload: {
            client: 'default',
            request: {
                url: `projects/${projectId}/chats/${chatId}/read`,
                method: 'post',
                data: {
                    messageIds
                }
            }
        }
    };
}

export function postProjectChatsMessage(projectId, chatId, data) {
    return {
        type: PROJECTS.POST_PROJECT_CHATS_MESSAGE,
        payload: {
            client: 'default',
            request: {
                url: `projects/${projectId}/chats/${chatId}/messages`,
                method: 'post',
                data
            }
        }
    };
}

export function getProjectEmployeesForAdding(companyId, id) {
    return {
        type: PROJECTS.GET_PROJECT_EMPLOYEES_FOR_ADDING,
        payload: {
            client: 'default',
            request: {
                url: `companies/${companyId}/projects/${id}/employees/for-adding`,
                method: 'get'
            }
        }
    };
}

export function getProjectClientsForAdding(companyId, id) {
    return {
        type: PROJECTS.GET_PROJECT_CLIENTS_FOR_ADDING,
        payload: {
            client: 'default',
            request: {
                url: `companies/${companyId}/projects/${id}/clients/for-adding`,
                method: 'get'
            }
        }
    };
}

export function postProjectMembersCreate(data, id) {
    return {
        type: PROJECTS.POST_PROJECT_MEMBERS_LIST,
        payload: {
            client: 'default',
            request: {
                url: `projects/${id}/members`,
                method: 'post',
                data
            }
        }
    };
}

export function getProjectNotifications(projectId) {
    return {
        type: PROJECTS.GET_PROJECTS_NOTIFICATIONS,
        payload: {
            client: 'default',
            request: {
                url: `me/projects/${projectId}/notifications`,
                method: 'get'
            }
        }
    };
}

export function patchProjectNotifications(data, projectId) {
    return {
        type: PROJECTS.PATCH_PROJECTS_NOTIFICATIONS,
        payload: {
            client: 'default',
            request: {
                url: `me/projects/${projectId}/notifications`,
                method: 'patch',
                data
            }
        }
    };
}

export function createProject(data) {
    return {
        type: PROJECTS.CREATE_PROJECT,
        payload: {
            client: 'default',
            request: {
                url: `projects`,
                method: 'post',
                data
            }
        }
    };
}

export function editProject(data, id) {
    return {
        type: PROJECTS.EDIT_PROJECT,
        payload: {
            client: 'default',
            request: {
                url: `projects/${id}`,
                method: 'post',
                data
            }
        }
    };
}

export function editProjectType(id, data) {
    return {
        type: PROJECTS.EDIT_PROJECT,
        payload: {
            client: 'default',
            request: {
                url: `projects/types/${id}`,
                method: 'post',
                data: {
                    name: data
                }
            }
        }
    };
}

export function projectMemberRemove(projectId, userId) {
    return {
        type: PROJECTS.PROJECT_MEMBER_REMOVE,
        payload: {
            client: 'default',
            request: {
                url: `projects/${projectId}/members/${userId}/remove`,
                method: 'delete'
            }
        }
    };
}
export function projectRemove(projectId) {
    return {
        type: PROJECTS.PROJECT_REMOVE,
        payload: {
            client: 'default',
            request: {
                url: `projects/${projectId}`,
                method: 'delete'
            }
        }
    };
}

export function getProjectTypes() {
    return {
        type: PROJECTS.GET_PROJECT_TYPES,
        payload: {
            client: 'default',
            request: {
                url: `projects/types`,
                method: 'get'
            }
        }
    };
}

export function resetProject() {
    return {
        type: PROJECTS.RESET_PROJECT,
        payload: {}
    };
}

export function resetProjectParticipants() {
    return {
        type: PROJECTS.RESET_PROJECT_PARTICIPANTS,
        payload: {}
    };
}

export function downloadProject(id) {
    return {
        type: PROJECTS.DOWNLOAD_PROJECT,
        payload: {
            client: 'default',
            request: {
                url: `projects/${id}/download`,
                method: 'get',
                responseType: 'blob'
            }
        }
    };
}

export function finishProject(id) {
    return {
        type: PROJECTS.PATCH_FINISH_PROJECT,
        payload: {
            client: 'default',
            request: {
                url: `projects/${id}/finish`,
                method: 'patch'
            }
        }
    };
}

export function resumeOrStartProject(id) {
    return {
        type: PROJECTS.PATCH_RESUME_OR_START_PROJECT,
        payload: {
            client: 'default',
            request: {
                url: `projects/${id}/resume`,
                method: 'patch'
            }
        }
    };
}

export function pauseProject(id) {
    return {
        type: PROJECTS.PATCH_PAUSE_PROJECT,
        payload: {
            client: 'default',
            request: {
                url: `projects/${id}/pause`,
                method: 'patch'
            }
        }
    };
}

export function addProjectType(data) {
    return {
        type: PROJECTS.ADD_PROJECT_TYPE,
        payload: {
            client: 'default',
            request: {
                url: `projects/types`,
                method: 'post',
                data
            }
        }
    };
}


export function updateCountByProjectId(id, count, type) {
    return {
        type: PROJECTS.UPDATE_COUNT_GENERAL,
        payload: {
            id,
            count,
            type
        }
    };
}


export function updateCountChatById(id, count, type, onlyCountOld) {
    return {
        type: PROJECTS.UPDATE_COUNT_IN_PROJECT,
        payload: {
            id,
            count,
            type,
            onlyCountOld
        }
    };
}

export function getChatMessage(projectId, chatId, messageId) {
    return {
        type: PROJECTS.GET_CHAT_MESSAGE,
        payload: {
            client: 'default',
            request: {
                url: `projects/${projectId}/chats/${chatId}/messages/${messageId}`,
                method: 'get'
            }
        }

    };
}
export function setFilterStatusProject(filter) {
    return {
        type: PROJECTS.PROJECT_SET_FILTER_STATUS,
        payload: filter
    }
}
